import React from 'react';
import bemClassName from 'bem-classname';

const className = bemClassName.bind(null, 'smart-menu');

export default class SmartMenu extends React.Component {

	static propTypes = {
		items: React.PropTypes.object,
		value: React.PropTypes.string,
		additionals: React.PropTypes.array,
		urls: React.PropTypes.object,
		onItemClick: React.PropTypes.func,
	};

	handleClick(item, e) {
		this.props.onItemClick && this.props.onItemClick(item, e);
	}

	render() {
		const { items, additionals, value, urls } = this.props;

		return (
			<div className={className()}>
				<ul className={`container ${className('list')}`}>
					{items.map((label, key) => (
						<li className={className('item', { current: key === value, additional: additionals.indexOf(key) !== -1 })} key={key}>
							<a
								className={className('link')}
								onClick={e => this.handleClick(key, e)}
								{...(urls[key] ? { href: urls[key] } : {})}
							>
								{label}
							</a>
						</li>
					)).toArray()}
				</ul>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/react/components/SmartMenu/SmartMenu.js